export default __webpack_public_path__ + "static/media/sounds/troMultiChoiceReadingCheckSentence.mp3";